module.exports = __webpack_public_path__ + "static/media/1 32 drømte.20c712ab.mp3";